import { useEffect, useRef } from "react";
import Lottie from "react-lottie-player";
import fireAnimation from "./Fire2.json"; // your downloaded Lottie file

export default function FireFill({ intensity }) {
    const lottieRef = useRef(null);

    useEffect(() => {
        if (lottieRef.current) {
            const startFrame = 12;
            const endFrame = 27;
            const clampedIntensity = Math.max(1, Math.min(intensity, 10)); // keep between 1-10

            // Map 1 → startFrame, 10 → endFrame
            const frame =
                startFrame +
                ((clampedIntensity - 1) / 9) * (endFrame - startFrame);

            lottieRef.current.goToAndStop(frame, true);
        }
    }, [intensity]);

    return (
        <Lottie
            ref={lottieRef}
            animationData={fireAnimation}
            loop={false}
            play={false}
            style={{ width: 50, height: 50 }}
        />
    );
}
